'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = require('./plugin');

module.exports = function (_Plugin) {
  _inherits(Wheel, _Plugin);
  /**
   * @private
   * @param {Viewport} parent
   * @param {object} [options]
   * @param {number} [options.percent=0.1] percent to scroll with each spin
   * @param {number} [options.smooth] smooth the zooming by providing the number of frames to zoom between wheel spins
   * @param {boolean} [options.interrupt=true] stop smoothing with any user input on the viewport
   * @param {boolean} [options.reverse] reverse the direction of the scroll
   * @param {PIXI.Point} [options.center] place this point at center during zoom instead of current mouse position
   *
   * @event wheel({wheel: {dx, dy, dz}, event, viewport})
   */


  function Wheel(parent, options) {
    _classCallCheck(this, Wheel);

    var _this = _possibleConstructorReturn(this, (Wheel.__proto__ || Object.getPrototypeOf(Wheel)).call(this, parent));

    options = options || {};
    _this.percent = options.percent || 0.1;
    _this.center = options.center;
    _this.reverse = options.reverse;
    _this.smooth = options.smooth;
    _this.interrupt = typeof options.interrupt === 'undefined' ? true : options.interrupt;
    return _this;
  }

  _createClass(Wheel, [{
    key: 'down',
    value: function down() {
      if (this.interrupt) {
        this.smoothing = null;
      }
    }
  }, {
    key: 'update',
    value: function update() {
      if (this.smoothing) {
        var point = this.smoothingCenter;
        var change = this.smoothing;
        var oldPoint = void 0;

        if (!this.center) {
          oldPoint = this.parent.toLocal(point);
        }

        this.parent.scale.x += change.x;
        this.parent.scale.y += change.y;
        this.parent.emit('zoomed', {
          viewport: this.parent,
          type: 'wheel'
        });
        var clamp = this.parent.plugins['clamp-zoom'];

        if (clamp) {
          clamp.clamp();
        }

        if (this.center) {
          this.parent.moveCenter(this.center);
        } else {
          var newPoint = this.parent.toGlobal(oldPoint);
          this.parent.x += point.x - newPoint.x;
          this.parent.y += point.y - newPoint.y;
        }

        this.smoothingCount++;

        if (this.smoothingCount >= this.smooth) {
          this.smoothing = null;
        }
      }
    }
  }, {
    key: 'wheel',
    value: function wheel(e) {
      if (this.paused) {
        return;
      }

      var point = this.parent.getPointerPosition(e);
      var sign = void 0;

      if (this.reverse) {
        sign = e.deltaY > 0 ? 1 : -1;
      } else {
        sign = e.deltaY < 0 ? 1 : -1;
      }

      var change = 1 + this.percent * sign;

      if (this.smooth) {
        var original = {
          x: this.smoothing ? this.smoothing.x * (this.smooth - this.smoothingCount) : 0,
          y: this.smoothing ? this.smoothing.y * (this.smooth - this.smoothingCount) : 0
        };
        this.smoothing = {
          x: ((this.parent.scale.x + original.x) * change - this.parent.scale.x) / this.smooth,
          y: ((this.parent.scale.y + original.y) * change - this.parent.scale.y) / this.smooth
        };
        this.smoothingCount = 0;
        this.smoothingCenter = point;
      } else {
        var oldPoint = void 0;

        if (!this.center) {
          oldPoint = this.parent.toLocal(point);
        }

        this.parent.scale.x *= change;
        this.parent.scale.y *= change;
        this.parent.emit('zoomed', {
          viewport: this.parent,
          type: 'wheel'
        });
        var clamp = this.parent.plugins['clamp-zoom'];

        if (clamp) {
          clamp.clamp();
        }

        if (this.center) {
          this.parent.moveCenter(this.center);
        } else {
          var newPoint = this.parent.toGlobal(oldPoint);
          this.parent.x += point.x - newPoint.x;
          this.parent.y += point.y - newPoint.y;
        }
      }

      this.parent.emit('moved', {
        viewport: this.parent,
        type: 'wheel'
      });
      this.parent.emit('wheel', {
        wheel: {
          dx: e.deltaX,
          dy: e.deltaY,
          dz: e.deltaZ
        },
        event: e,
        viewport: this.parent
      });

      if (!this.parent.passiveWheel) {
        e.preventDefault();
      }
    }
  }]);

  return Wheel;
}(Plugin);